import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['Substation'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getSubstationById: build.query<GetSubstationByIdApiResponse, GetSubstationByIdApiArg>({
        query: (queryArg) => ({ url: `/Substation/${queryArg}` }),
        providesTags: ['Substation'],
      }),
      deleteSubstationById: build.mutation<DeleteSubstationByIdApiResponse, DeleteSubstationByIdApiArg>({
        query: (queryArg) => ({ url: `/Substation/${queryArg}`, method: 'DELETE' }),
        invalidatesTags: ['Substation'],
      }),
      getSubstationGetAll: build.query<GetSubstationGetAllApiResponse, GetSubstationGetAllApiArg>({
        query: () => ({ url: `/Substation/get-all` }),
        providesTags: ['Substation'],
      }),
      getSubstationGetSubstationDeviceHierarchy: build.query<
        GetSubstationGetSubstationDeviceHierarchyApiResponse,
        GetSubstationGetSubstationDeviceHierarchyApiArg
      >({
        query: (queryArg) => ({
          url: `/Substation/get-substation-device-hierarchy`,
          params: {
            tsoId: queryArg,
          },
        }),
        providesTags: ['Substation'],
      }),
      getSubstationByIdIsReferenced: build.query<
        GetSubstationByIdIsReferencedApiResponse,
        GetSubstationByIdIsReferencedApiArg
      >({
        query: (queryArg) => ({ url: `/Substation/${queryArg}/is-referenced` }),
        providesTags: ['Substation'],
      }),
      postSubstation: build.mutation<PostSubstationApiResponse, PostSubstationApiArg>({
        query: (queryArg) => ({ url: `/Substation`, method: 'POST', body: queryArg }),
        invalidatesTags: ['Substation'],
      }),
      putSubstation: build.mutation<PutSubstationApiResponse, PutSubstationApiArg>({
        query: (queryArg) => ({ url: `/Substation`, method: 'PUT', body: queryArg }),
        invalidatesTags: ['Substation'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as substationApi };
export type GetSubstationByIdApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoSubstationExternalDto;
export type GetSubstationByIdApiArg = number;
export type DeleteSubstationByIdApiResponse = unknown;
export type DeleteSubstationByIdApiArg = number;
export type GetSubstationGetAllApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoSubstationExternalDto;
export type GetSubstationGetAllApiArg = void;
export type GetSubstationGetSubstationDeviceHierarchyApiResponse =
  /** status 200 OK */ ApiCommonResponsesSubstationsDeviceHierarchyResponse;
export type GetSubstationGetSubstationDeviceHierarchyApiArg = /** Optional TSO ID to filter the hierarchy */
  | number
  | undefined;
export type GetSubstationByIdIsReferencedApiResponse = /** status 200 OK */ boolean;
export type GetSubstationByIdIsReferencedApiArg = /** Substation ID */ number;
export type PostSubstationApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoSubstationExternalDto;
export type PostSubstationApiArg = ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoSubstationExternalDto;
export type PutSubstationApiResponse = unknown;
export type PutSubstationApiArg = ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoSubstationExternalDto;
export type ApiCommonExternalDtoSubstationExternalDto = {
  id?: number;
  tsoId?: number;
  name: string;
  latitude?: number | null;
  longitude?: number | null;
  comment: string;
};
export type ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoSubstationExternalDto = {
  externalDto?: ApiCommonExternalDtoSubstationExternalDto;
  externalDtos?: ApiCommonExternalDtoSubstationExternalDto[] | null;
};
export type ApiDatabaseCommonDeviceHierarchyType = 0 | 1 | 2;
export type ApiDatabaseDtOsSubstationsDeviceHierarchyDto = {
  id?: string | null;
  entityId?: number;
  tsoId?: number;
  label?: string | null;
  type?: ApiDatabaseCommonDeviceHierarchyType;
  options?: ApiDatabaseDtOsSubstationsDeviceHierarchyDto[] | null;
};
export type ApiCommonExternalDtoSubstationsDeviceHierarchyExternalDto = {
  id: string;
  entityId?: number;
  tsoId?: number;
  label: string;
  type: ApiDatabaseCommonDeviceHierarchyType;
  options?: ApiDatabaseDtOsSubstationsDeviceHierarchyDto[] | null;
};
export type ApiCommonResponsesSubstationsDeviceHierarchyResponse = {
  externalDtos?: ApiCommonExternalDtoSubstationsDeviceHierarchyExternalDto[] | null;
};
export type ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoSubstationExternalDto = {
  externalDto?: ApiCommonExternalDtoSubstationExternalDto;
};
export const {
  useGetSubstationByIdQuery,
  useLazyGetSubstationByIdQuery,
  useDeleteSubstationByIdMutation,
  useGetSubstationGetAllQuery,
  useLazyGetSubstationGetAllQuery,
  useGetSubstationGetSubstationDeviceHierarchyQuery,
  useLazyGetSubstationGetSubstationDeviceHierarchyQuery,
  useGetSubstationByIdIsReferencedQuery,
  useLazyGetSubstationByIdIsReferencedQuery,
  usePostSubstationMutation,
  usePutSubstationMutation,
} = injectedRtkApi;
